"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltairPanel = exports.AltairPanelLocation = void 0;
var uuid_1 = require("uuid");
var AltairPanelLocation;
(function (AltairPanelLocation) {
    AltairPanelLocation["HEADER"] = "header";
    AltairPanelLocation["SIDEBAR"] = "sidebar";
    AltairPanelLocation["RESULT_PANE_BOTTOM"] = "result_pane_bottom";
})(AltairPanelLocation = exports.AltairPanelLocation || (exports.AltairPanelLocation = {}));
/**
 * Used for dynamic panel elements. Can also be used for angular components in the future.
 */
var AltairPanel = /** @class */ (function () {
    function AltairPanel(title, element, location) {
        this.title = title;
        this.element = element;
        this.location = location;
        this.id = uuid_1.v4();
        this.isActive = false;
    }
    AltairPanel.prototype.destroy = function () {
        this.element = null;
    };
    return AltairPanel;
}());
exports.AltairPanel = AltairPanel;
